<template>
  <v-dialog v-model="internalDialogVisible" max-width="75%">
    <v-card v-if="selectedItem">
      <v-card-title class="primary">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          lazy-validation>
          <v-container>
            <v-row>
                <v-col cols="6" sm="6" md="6">
                    <v-text-field
                        v-model="formItem.Name"
                        label="Staff Name"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                      v-model="formItem.PhoneNumber"
                      label="Phone Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="birthMenu"
                    v-model="birthMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="formItem.BirthDate"
                          label="Birthday"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="formItem.BirthDate"
                        :active-picker.sync="activePicker"
                        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="$refs.birthMenu.save(formItem.BirthDate)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                      ref="anniversaryMenu"
                      v-model="anniversaryMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formItem.AnniversaryDate"
                        label="Anniversary date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formItem.AnniversaryDate"
                      :active-picker.sync="activePicker"
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="$refs.anniversaryMenu.save(formItem.AnniversaryDate)"
                    ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="formItem.PhoneCarrier"
                      label="Phone Carrier"
                      :rules="requiredField"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="formItem.Email"
                            label="Email"
                            v-on="on"
                            :disabled="editEmail"
                            :rules="emailRules"
                        ></v-text-field>
                      </template>
                      <span>This email will be used to login in the account.</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formItem.Date"
                          label="Date Hired"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formItem.Date"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu1 = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu1.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="formItem.Address"
                      label="Address"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                        v-model="formItem.City"
                        label="City"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="formItem.State"
                      label="State"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="formItem.Zip"
                      label="Zip"
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select
                      :items="droles"
                      label="Role"
                      outlined
                      v-model="formItem.Role"
                    ></v-select>
                  </v-col>
                  <v-col 
                    class="d-flex" 
                    cols="12" 
                    sm="6"
                    v-if="Role == 'Administration'"
                  >
                    <v-select
                      v-model="formItem.Program"
                      label="Program"
                      :items="programs"
                      item-text="Name"
                      item-value="Name"
                      multiple
                    ></v-select>
                  </v-col>
                  <v-col 
                    class="d-flex" 
                    cols="12" 
                    sm="6"
                    v-if="Role != 'Administration'"
                  >
                    <v-select
                        v-model="formItem.Program"
                        label="Program"
                        :items="programs"
                        item-text="Name"
                        item-value="Name"
                        multiple
                        readonly
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6">
                    <v-autocomplete
                      :items="estatus"
                      outlined
                      label="Status"
                      v-model="formItem.Status"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            class="white--text" color="#259647" @click="updateEmployee()">Update
        </v-btn
        >
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'
import Swal from 'sweetalert2'
import { mapState } from 'vuex';
import moment from 'moment';
const url = require("../../../client_config/config").url;

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      required: true
    },
    programs: {
      type: Array,
      required: true
    },
    selectedItem:{
      type: Object,
      default: () => null
    }
  },
  data: function(){
    return {
      on: false,
      date: null,
      menu: false,
      menu1: false,
      birthMenu: false,
      anniversaryMenu: false,
      activePicker: null,
      birthDate: null,
      anniversaryDate: null,
      administration: false,
      directCareStaff: false,
      assistantManager: false,
      houseManager: false,
      programManager: false,
      humanResources: false,
      clientServicesManager: false,
      programCoordinator: false,
      executiveDirector: false,
      financeManager: false,
      complianceManager: false,
      parentGuardian: false,
      supportCoordinator: false,
      client: false,
      adddialog: false,
      editdialog: false,
      passdialog: false,
      editEmail: false,
      editEmployee: false,
      newEmployee: false,
      msg: false,
      search: "",
      text: "",
      position: ["Admin", "House Manager", "Assistant Manager", "Direct Care Staff"],
      estatus: ["Full-Time", "Part-Time"],
      employees: [],
      users: [],
      staffID: "",
      titleForm: "New Staff",
      employeeID: "",
      newName: "",
      newPassword: "",
      newRePass: "",
      newPhone: "",
      newPhoneCarrier: "",
      newDate: "",
      newRole: "",
      newProgram: "",
      newSecurityQuestion: "",
      newEmail: "",
      newAddress: "",
      newCity: "",
      newState: "",
      newZip: "",
      newPosition: "",
      newStatus: "",
      birthday: "",
      anniversary: "",
      Role: localStorage.getItem('userRole'),
      editedIndex: -1,
      userState: localStorage.getItem('userState'),
      former: [],
      temp: [],
      editedItem: {
          name: "",
          phone: "",
          email: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          position: "",
          status: "",
      },
      defaultItem: {
          name: "",
          phone: "",
          email: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          position: "",
          status: "",
      },
      page: 1,
      pageCount: 1,
      itemCount: 0,
      options: {},
      isLoading: true,
      requiredField: [
          v => !!v || 'This is required',
      ],
      emailRules: [
          v => !!v || 'This is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      internalDialogVisible: this.dialogVisible,
      formItem: { ...this.selectedItem },
    }
  },
  watch: {
    dialogVisible(newVal) {
      this.internalDialogVisible = newVal;
    },
    internalDialogVisible(newVal) {
      if (!newVal) {
        this.$emit('closeDialog');
      }
    },
    selectedItem(newVal) {
      if(newVal?.AnniversaryDate == null || newVal?.AnniversaryDate == "" ){
        newVal.AnniversaryDate = newVal.Date; // IF NULL USE HIRED DATE AS ANNIVERSARY DATE
      }
      this.formItem = { ...newVal,  };
    }
  },
  computed: {
    ...mapState({
        droles: 'userRoles',
    }),
  },

  created() {
   
  },

  methods: {

    close() {
      this.internalDialogVisible = false;
    },

    checkDate(date) {
      let isDateValid = isNaN(Date.parse(date))
      if (isDateValid) {
          return date = ""
      }
      return moment(date).format('YYYY-MM-DD')
    },

    updateEmployee() {
      Swal.fire({
        title: 'Please wait...',
        text: 'Updating user...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      this.$delete(this.formItem, "Company");
      const data = { ...this.formItem };
  
      var req_body = data ;
      axios.put(`${url}/employees/${data._id}`, req_body).then((response) => {
        if (response.status === 400) {
          response.json().then(function (data) {
              alert(data.msg);
          });
        }
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: "The user has been updated successfully.",
        }).then((result) => {
            if (result.value) {
              this.close();
            }
        });
      }); 
    },
  }
}
</script>